import React from 'react';
import styled from 'styled-components';

const CourseCard = styled.div`
    width: 100%;
    max-width: 30.3333%;
    margin: 1.5%;
    height: 418px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 30.3333%;
    
    @media(max-width: 1050px) {
        max-width: 47%;
        flex-basis: 47%;
    }
    @media(max-width: 1050px) {
        max-width: 100%;
        flex-basis: 100%;
    }
    
    &.singleCard {
        max-width: 100%;
        flex-wrap: wrap;
        height: 418x;
    }

    &.largeCard {
        max-width: 63.3333%;
        flex-wrap: wrap;
        flex: 2 2 63.3333%;
        height: 418x;
        @media(max-width: 1050px) {
            max-width: 47%;
            flex-basis: 47%;
        }
        @media(max-width: 1050px) {
            max-width: 100%;
        }
    }
`

const GridItem = ({ index, cardsQuantity, isPlaceholder, isLoading, children }) => {

    const getCardClass = () => {
        if (cardsQuantity === 1 || isPlaceholder )
            return 'singleCard'
            
        if((cardsQuantity > 1 && index === 0) || (isLoading && index === 0))
            return 'largeCard'
    }

    return (
        <CourseCard className={getCardClass()}>{ children }</CourseCard>
    )
}

GridItem.defaultProps = {
    isUserCourse: false,
    isLoading: false,
    isPlaceholder: false
}

export default GridItem